/**
*
* RegionSelector
*
*/

import React from 'react';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import 'css/components/region_chooser.sass';
import 'react-accessible-accordion/dist/minimal-example.css';

import { makeSelectEntities } from 'models/selectors';
import { makeSelectCurrentRegionId } from 'containers/App/selectors';
import { setCurrentRegionId } from 'containers/App/actions';

import ClickOutside from 'react-click-outside'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import * as metricsActions from 'containers/App/metricsActions'


class RegionSelector extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor (props) {
    super(props);
    this.state = { expanded: false };
    this.onChoose = this.onChoose.bind(this);
  }

  onChoose (id) {
    // this.setState({expanded: true})
    this.props.setCurrentRegionId(id);
    this.setState({ expanded: false });
  }

  render () {
    const { regionId, regions, sendRaw } = this.props;
    const regionItems = Object.values(regions).sort((a, b) => {
      // console.log(b.name.toLowerCase(), b.name.toLowerCase()==='москва')
      if(a.name.toLowerCase() === 'москва' || a.name.toLowerCase() === 'санкт-петербург') {
        return -1;
      } else if(b.name.toLowerCase() === 'москва' || b.name.toLowerCase() === 'санкт-петербург') {
        return 1;
      } else {
        return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      }
    });
    const currentRegionName = regionId && regionId && regions[regionId] ? regions[regionId].name : 'Россия';
    return (
      <div className="region-chooser">
        <span className="region-chooser__selector" >
          Регион:&nbsp;
          <span className='hoverable' onClick={() => { sendRaw('PartsPage', 'link_click_region'); this.setState({expanded: true})}}>
            {currentRegionName}
          </span>
        </span>
        {this.state.expanded && 
          <div className="region-chooser__popup">
            <div className="region-chooser__close hoverable" onClick={() => this.setState({expanded: false}) }>
              <FontAwesomeIcon icon={faTimes} />
            </div>
            <ClickOutside onClickOutside={() => this.setState({expanded: false}) } >
              <div className="region-chooser__items">
                <div className='region-chooser__col'>
                  <div className="region-chooser__item" onClick={() => { sendRaw('PartsPage', 'choose_region', 'Россия'); this.onChoose(null); }}>
                    Россия
                  </div>              
                  {regionItems && regionItems.slice(0, Math.floor(regionItems.length/2)).map((one, i) => (
                    <div key={`region-${one.id}`} className='region-chooser__item'  onClick={() => { sendRaw('PartsPage', 'choose_region', one.name); this.onChoose(one.id); }}>
                      {one.name}
                    </div>
                  ))}
                </div>
                <div className='region-chooser__col'>
                  {regionItems && regionItems.slice(Math.floor(regionItems.length/2)).map((one, i) => (
                    <div key={`region-${one.id}`} className='region-chooser__item'  onClick={() => { sendRaw('PartsPage', 'choose_region', one.name); this.onChoose(one.id); }}>
                      {one.name}
                    </div>
                  ))}
                </div>              
              </div>
            </ClickOutside>
          </div>
        }
      </div>

    );
  }
}

RegionSelector.propTypes = {

};

const mapStateToProps = createStructuredSelector({
  regions: makeSelectEntities('regions'),
  regionId: makeSelectCurrentRegionId(),
});

function mapDispatchToProps (dispatch) {
  return {
    setCurrentRegionId: (regionId) => dispatch(setCurrentRegionId(regionId)),
    sendRaw: (c, a, l) => dispatch(metricsActions.sendRaw(c, a, l))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withConnect
)(RegionSelector);
